import React, { useState, useEffect } from 'react';
import { ReactSortable } from 'react-sortablejs';
import './StudioCategoriesList.scss';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../../config.js';
import { BackButton } from '../../components/BackButton/BackButton.jsx';
import { Loader } from '../../components/Loader/Loader.jsx';
import { ModalMessage } from '../../components/ModalMessage/ModalMessage.jsx';
import { Logout } from '../../components/Logout/Logout.jsx';

export const StudioCategoriesList = () => {
	const [studios, setStudios] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);

	const getStudios = async () => {
		setLoading(true);
		try {
			const { data: response } = await Axios.get(`${API_URL}/studio`);
			setStudios(response.data);
		} catch (error) {
			console.log(error);
			setError(error.message);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getStudios();
	}, []);

	const deleteStudio = async (id) => {
		const confirm = window.confirm(
			'¿Estás seguro de que quieres eliminar esta categoría?'
		);
		if (!confirm) return;
		try {
			const { data: response } = await Axios.delete(
				`${API_URL}/studio/${id}`
			);
			setMessage(response.message);
			getStudios();
		} catch (error) {
			console.log(error);
			setError(error.message);
		}
	};

	const handleSortUpdate = async (newOrder) => {
		const orderedIds = newOrder.map((studio) => studio._id);
		try {
			await Axios.patch(
				`${API_URL}/studio/order`,
				{ orderedIds },
				{ headers: { 'Content-Type': 'application/json' } }
			);
			setMessage('Orden actualizado correctamente');
		} catch (err) {
			console.error('❌ Error al actualizar orden:', err);
			setError(
				'Error al actualizar el orden de las categorías de estudio'
			);
		}
	};

	return (
		<div className='StudioCategoriesList'>
			{loading && <Loader />}

			<div className='container'>
				<BackButton to='/dashboard' text='Dashboard' />
				<Logout />
				<br />
				<h3>CATEGORÍAS DE ESTUDIO</h3>

				{message && (
					<ModalMessage
						type='success'
						message={message}
						onClose={() => setMessage(null)}
					/>
				)}
				{error && (
					<ModalMessage
						type='error'
						message={error}
						onClose={() => setError(null)}
					/>
				)}

				{studios.length === 0 ? (
					<h4>No hay categorías todavía</h4>
				) : (
					<ReactSortable
						list={studios}
						setList={setStudios}
						ghostClass='dropArea'
						handle='.dragHandle'
						filter='.ignoreDrag'
						preventOnFilter={true}
						onEnd={({ oldIndex, newIndex }) => {
							if (oldIndex !== newIndex) {
								const newOrder = [...studios];
								const [movedItem] = newOrder.splice(
									oldIndex,
									1
								);
								newOrder.splice(newIndex, 0, movedItem);
								setStudios(newOrder);
								handleSortUpdate(newOrder);
							}
						}}
					>
						{studios.map((studio) => (
							<div
								className='studioCategory dragHandle'
								key={studio._id}
							>
								<img
									src={studio.image1?.secure_url}
									alt='studio'
								/>
								<h4>{studio.title}</h4>
								<div className='btn-container'>
									<Link
										className='editButton'
										to={`/edit-studioCategory/${studio._id}`}
									>
										<img
											className='editIcon'
											src={require('../../assets/icons/editar.png')}
											alt='edit-icon'
										/>
									</Link>
									<button
										className='deleteButton'
										onClick={() => deleteStudio(studio._id)}
									>
										X
									</button>
								</div>
							</div>
						))}
					</ReactSortable>
				)}
			</div>
		</div>
	);
};
